const MAIN_PATHS = new Set([
  '/',
  '/illuminate',
  '/execute',
  '/execute/longevity',
  '/knowledge',
  '/ask',
  '/generosity',
  '/dev',
]);

export function isMainAppPath(pathname: string) {
  return MAIN_PATHS.has(pathname);
}

export function resolveBackTarget(pathname: string) {
  const parts = pathname.split('/').filter(Boolean);

  if (pathname === '/' || pathname === '/illuminate') return '/illuminate';
  if (pathname.startsWith('/illuminate/report/')) return '/illuminate/reports';
  if (pathname.startsWith('/illuminate/')) return '/illuminate';

  if (pathname === '/ask') return '/ask';
  if (pathname.startsWith('/ask/question/')) return '/ask/questions';
  if (pathname.startsWith('/ask/')) return '/ask';

  if (pathname === '/assess/hub') return '/illuminate';
  if (pathname.startsWith('/assess/')) return '/assess/hub';
  if (pathname === '/assess') return '/assess/hub';

  if (pathname === '/execute' || pathname === '/execute/longevity') return '/execute/longevity';
  if (parts[0] === 'execute' && parts[1] === 'longevity' && parts[2] === 'day' && parts[3] && parts[4] === 'cards') {
    return `/execute/longevity/day/${parts[3]}`;
  }
  if (pathname.startsWith('/execute/longevity/day/')) return '/execute/longevity';
  if (pathname.startsWith('/execute/longevity/')) return '/execute/longevity';
  if (pathname.startsWith('/execute/intervention/') && pathname.endsWith('/intro')) return '/execute/interventions';
  if (pathname === '/execute/interventions') return '/execute/longevity';
  if (pathname.startsWith('/execute/recipe/')) return '/execute/recipes';
  if (pathname === '/execute/recipes') return '/execute/longevity';
  if (pathname.startsWith('/execute/plan/')) return '/execute/longevity';
  if (pathname.startsWith('/execute/reversal/') && pathname.endsWith('/intro')) return '/execute/reversal';
  if (pathname === '/execute/reversal') return '/execute/longevity';
  if (pathname.startsWith('/execute/')) return '/execute/longevity';

  if (pathname === '/knowledge') return '/knowledge';
  if (pathname === '/knowledge/podcasts') return '/knowledge';
  if (parts[0] === 'knowledge' && parts[1] === 'podcasts' && parts[2] && parts[3] === 'episodes' && parts[4] && parts[5] === 'cards') {
    return `/knowledge/podcasts/${parts[2]}/episodes/${parts[4]}`;
  }
  if (parts[0] === 'knowledge' && parts[1] === 'podcasts' && parts[2] && parts[3] === 'episodes') {
    return `/knowledge/podcasts/${parts[2]}`;
  }
  if (parts[0] === 'knowledge' && parts[1] === 'podcasts' && parts[2]) return '/knowledge/podcasts';
  if (pathname === '/knowledge/custom-courses') return '/knowledge/podcasts';
  if (pathname.startsWith('/knowledge/custom-course/')) return '/knowledge';
  if (pathname.startsWith('/knowledge/')) return '/knowledge';

  if (pathname === '/profile') return '/illuminate';
  if (pathname === '/membership') return '/profile';
  if (pathname === '/membership/redeem') return '/membership';
  if (pathname.startsWith('/profile/family/compare')) return '/profile/family';
  if (pathname.startsWith('/profile/')) return '/profile';
  if (pathname === '/settings') return '/profile';

  if (pathname === '/calendar') return '/illuminate';
  if (pathname === '/calendar/add') return '/calendar';
  if (pathname === '/checkout') return '/membership';
  if (pathname === '/favorites' || pathname.startsWith('/commerce/')) return '/profile';

  if (pathname.startsWith('/generosity/')) return '/generosity';
  if (pathname === '/generosity') return '/generosity';

  if (pathname.startsWith('/onboarding/not-fit')) return '/splash';
  if (pathname.startsWith('/invite/')) return '/login';

  return '/illuminate';
}
